import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import bind from "memoize-bind";
import ParticipiantsRepository from "lib/repositories/ParticipiantsRepository";
import { SubBar, MainView, SidebarView, OrdersList, Button, PaginationNavigation, Message, st } from "lib/index";
import { open as openNewOrderModal } from "modules/orders/NewOrderModal";
import {
  stateSelector,
  initializeView,
  destroyView,
  setParamsWithLocationQuery,
  changeFilters,
  changePagination,
  fetchRecords,
  changeFiltersAndResetOffset,
} from "./index";
import OrdersListFilters from "./OrdersListFilters";
import { CSVLink, CSVDownload } from "react-csv";

const getFormattedDate = (date) => {
  var today = new Date(date);
  var dd = today.getDate();

  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  return dd + "/" + mm + "/" + yyyy;
};

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    currentProducts: state.auth.products.model || [],
    sidebarVisible: state.app.sidebarVisible,
    filters: stateSelector(state).filters,
    offset: stateSelector(state).offset,
    limit: stateSelector(state).limit,
    records: stateSelector(state).records.model && stateSelector(state).records.model.records,
    totalCount: stateSelector(state).records.model && stateSelector(state).records.model.meta.total_count,
    aggregations: stateSelector(state).records.model && stateSelector(state).records.model.aggregations,
    fetchDone: stateSelector(state).records.fetchDone,
    fetchLoading: stateSelector(state).records.fetchLoading,
    fetchFailed: stateSelector(state).records.fetchFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        destroyView,
        setParamsWithLocationQuery,
        changeFilters,
        changePagination,
        fetchRecords,
        changeFiltersAndResetOffset,
        openNewOrderModal,
      },
      dispatch
    )
)
export default class OrdersListView extends React.PureComponent {
  state = {
    csvRecords: [],
  };
  componentDidMount() {
    this.props.initializeView();
    this.props.setParamsWithLocationQuery(this.props.location.query);
  }

  componentWillUnmount() {
    this.props.destroyView();
  }

  handleNewOrderClick() {
    this.props.openNewOrderModal();
  }
  getFileName() {
    var today = new Date();
    return "export_orders_" + getFormattedDate(today) + ".csv";
  }
  onExportClick = (event, done) => {
    let ids = [];
    this.props.records.map((r) => {
      ids.push(r.id);
    });
    ParticipiantsRepository.search(ids).subscribe((res) => {
      this.setState({ csvRecords: res.records.data.map((r) => r.attributes) });
      let btn = this.refs.csv;
      btn.link.click();
    });
  };

  getBooker = (order_id) => {
    try {
      const order = this.props.records.filter((r) => r.id === order_id);
      const name = order[0].customer_full_name;
      return name;
    } catch (e) {
      new Error("Unable to get booker for CSV export");
    }

    return "-";
  };

  render() {
    const {
      currentCompany,
      currentProducts,
      fetchRecords,
      changeFiltersAndResetOffset,
      fetchDone,
      fetchLoading,
      fetchFailed,
      records,
      aggregations,
      filters,
      offset,
      limit,
      totalCount,
      sidebarVisible,
      changeFilters,
      changePagination,
    } = this.props;

    const filename = this.getFileName();
    const { csvRecords } = this.state;
    const getBooker = this.getBooker;
    let exportData = {
      get data() {
        let result = [
          [
            "ID",
            I18n.humanAttributeName("order", "stock_useby_time_range"),
            I18n.humanAttributeName("order", "product_name"),
            I18n.humanAttributeName("order", "pickup_point"),
            I18n.humanAttributeName("order", "customer_full_name"),
            I18n.t("attributes.birth_date"),
            I18n.t("pdfs.order_voucher.contact_phone_number"),
            I18n.t("fe.order_details.paid_amount"),
            I18n.t("fe.order_details.total_amount_short"),
          ],
        ];

        for (let r of csvRecords) {
          let paid = r.order_customer_paid_amount_sum.map((r) => r.value)[0];
          let total = r.order_total_amount_sum.map((r) => r.value)[0];

          let entry = [
            r.order_id,
            getFormattedDate(r.order_stock_starts_at),
            r.order_name,
            r.pickup_point || "-",
            r.full_name || getBooker(r.order_id),
            r.birth_date,
            r.order_customer_phone_number || "-",
            paid ? ("" + paid).replace(".", ",") : 0,
            total ? ("" + total).replace(".", ",") : 0,
          ];
          result.push(entry);
        }

        return result;
      },
    };

    return (
      <SidebarView.Container>
        <SidebarView.Sidebar label={I18n.t("papp.common.filters_title")} extended={sidebarVisible}>
          <OrdersListFilters
            currentCompany={currentCompany}
            currentProducts={currentProducts}
            aggregations={aggregations}
            filters={filters}
            onFiltersChange={(filters) => changeFiltersAndResetOffset(filters)}
          />
        </SidebarView.Sidebar>

        <SidebarView.Content hasSidebar={sidebarVisible}>
          <MainView.Container>
            <SubBar hasSidebar={sidebarVisible}>
              <div className="pull-left u-inlineFlexRow">
                <h1>{I18n.t("papp.orders.OrdersListView.title")}</h1>
              </div>

              <div className="pull-right">
                {fetchDone && (
                  <Button
                    primary
                    as="a"
                    className="u-marginLeft"
                    onClick={this.onExportClick}
                    content={I18n.t("papp.common.download_csv")}
                  />
                )}
                {fetchDone && (
                  <CSVLink
                    data={exportData.data}
                    className="ui primary button u-marginRight"
                    filename={filename}
                    style={{ display: "none" }}
                    ref="csv"
                  >
                    Export Orders
                  </CSVLink>
                )}
                {fetchDone && totalCount > 0 && (
                  <PaginationNavigation
                    offset={offset}
                    limit={limit}
                    totalCount={totalCount}
                    onChange={changePagination}
                    name="ordersLimit"
                  />
                )}
                {(currentCompany.enable_saas || currentCompany.is_st) && (
                  <Button
                    primary
                    as="a"
                    className="u-marginLeft"
                    onClick={bind(this.handleNewOrderClick, this)}
                    content={I18n.t("papp.orders.OrdersListView.add_new_order")}
                  />
                )}
              </div>
            </SubBar>

            <MainView.Content grayBackground hasSubBar>
              <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchRecords} />
              {fetchDone && totalCount === 0 && (
                <MainView.DimmerContent
                  icon="sentiment_neutral"
                  title={I18n.t("papp.orders.OrdersListView.no_orders_title")}
                >
                  <p>
                    {I18n.t("papp.orders.OrdersListView.no_orders_message")}{" "}
                    <a className="u-cursorPointer" onClick={bind(this.handleNewOrderClick, this)}>
                      {I18n.t("papp.orders.OrdersListView.no_orders_add_new_button")}
                    </a>
                  </p>
                </MainView.DimmerContent>
              )}
              {fetchDone && totalCount > 0 && <OrdersList orders={records} />}
            </MainView.Content>
          </MainView.Container>
        </SidebarView.Content>
      </SidebarView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/OrdersListView/OrdersListView.jsx